import { render, staticRenderFns } from "./ContactPersons.vue?vue&type=template&id=7e40041f&"
import script from "./ContactPersons.vue?vue&type=script&lang=js&"
export * from "./ContactPersons.vue?vue&type=script&lang=js&"
import style0 from "./ContactPersons.vue?vue&type=style&index=0&id=7e40041f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports